import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import Layout from "@/components/Layout";
import { useAuth } from "@/contexts/AuthContext";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      await register(name, email, password);
      toast.success("Welcome to Norbu Collection");
      nav("/account", { replace: true });
    } catch (err) { toast.error(err.message); }
    finally { setBusy(false); }
  }

  return (
    <Layout>
      <div className="max-w-md mx-auto px-6 py-20">
        <div className="overline text-[#C9A227]">Become a member</div>
        <h1 className="mt-3 text-4xl font-light text-[#163A2F]">Create account</h1>
        <p className="mt-2 text-[#163A2F]/60 text-sm">Early access, faster checkout, order tracking.</p>

        <form onSubmit={submit} className="mt-10 space-y-5">
          <div>
            <label className="overline text-[#163A2F]/70">Full name</label>
            <input required value={name} onChange={(e) => setName(e.target.value)}
              data-testid="register-name"
              className="mt-1 w-full px-4 py-3 border hairline bg-transparent focus:outline-none focus:border-[#C9A227]" />
          </div>
          <div>
            <label className="overline text-[#163A2F]/70">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="register-email"
              className="mt-1 w-full px-4 py-3 border hairline bg-transparent focus:outline-none focus:border-[#C9A227]" />
          </div>
          <div>
            <label className="overline text-[#163A2F]/70">Password</label>
            <input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="register-password"
              className="mt-1 w-full px-4 py-3 border hairline bg-transparent focus:outline-none focus:border-[#C9A227]" />
            <p className="text-[11px] text-[#163A2F]/50 mt-1">Minimum 6 characters.</p>
          </div>
          <button type="submit" disabled={busy}
            data-testid="register-submit"
            className="w-full bg-[#163A2F] text-white py-4 uppercase text-xs tracking-[0.25em] hover:bg-[#0A1C16] transition-colors disabled:opacity-50"
          >
            {busy ? "Creating account…" : "Create account"}
          </button>
        </form>

        <p className="mt-6 text-sm text-[#163A2F]/70 text-center">
          Already a member? <Link to="/login" className="link-gold text-[#163A2F]">Sign in</Link>
        </p>
      </div>
    </Layout>
  );
}
